export default "__VITE_ASSET__BSXGoUX8__"